import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import useSWR from "swr";
import { fetchData } from "../../lib/dashboard/data";

const MarketWatchOptionContext = createContext();

const MarketWatchOptionProvider = ({ children }) => {
  const [valueChangeTableData, setValueChangeTableData] = useState({});

  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  const getApiEndpoint = (path) => {
    switch (path) {
      case "/dashboard/market-watch/options/call_value_change":
        return "/stock-market/option-value-change/call";
      case "/dashboard/market-watch/options/put_value_change":
        return "/stock-market/option-value-change/put";
      default:
        return null;
    }
  };

  const apiEndpoint = getApiEndpoint(pathname);
  const tableParams = searchParams.get("table");
  const data = useSWR([`${apiEndpoint}`, tableParams],
      ([url, params]) => fetchData(url, params),
      {
        dedupingInterval: 36000, // Deduplication interval
      }  );

  useEffect(() => {
    if (data) {
      setValueChangeTableData(data);
    }
  }, [data.data]);

  const valueChagneHighlightedCols = [
    "money_flow",
    "closing_price_change",
    "last_price_change",
  ];

  return (
    <MarketWatchOptionContext.Provider
      value={{
        valueChangeTableData,
        setValueChangeTableData,
        valueChagneHighlightedCols,
      }}
    >
      {children}
    </MarketWatchOptionContext.Provider>
  );
};

export default MarketWatchOptionProvider;

export const useMarketWatchOptionContext = () =>
  useContext(MarketWatchOptionContext);
